import { render, staticRenderFns } from "./image_amplify.vue?vue&type=template&id=4bd02afa&scoped=true&"
import script from "./image_amplify.vue?vue&type=script&lang=js&"
export * from "./image_amplify.vue?vue&type=script&lang=js&"
import style0 from "./image_amplify.vue?vue&type=style&index=0&id=4bd02afa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd02afa",
  null
  
)

export default component.exports